<template lang="pug">
  div(
    class="key-file-select"
    :class="{ errored: fileError, successed: fileSelected }"
  )
    div(class="key-file-select__input")
      div(class="d-flex align-center")
        input(
          v-show="false"
          @input="handleFileSelected"
          :accept="isIOS ? '' : '.dat,.pfx,.pk8,.zs2,.jks'"
          type="file"
          ref="fileInput"
          :key="fileInputKey"
        )
        div(class="key-file-select__input-key-icon mr-5")
          e-svg-icon(v-show="fileSelected") key-5-white
          e-svg-icon(v-show="!fileSelected") key-5
        div(class="key-file-select__input-text")
          div(class="text-14px medium dark") {{ fileName || text }}
          p(
            v-if="!fileSelected"
            class="text-12px light mb-0"
          ) {{ $t('Possible formats: *.dat, *.pfx, *.pk8, *.zs2, *.jks') }}
      v-btn(
        @click="handleFileSelect"
        class="secondary-button key-file-select__input-btn"
        outlined
      ) {{ buttonText }}
    div(
      v-if="fileError"
      class="key-file-select__error"
    ) {{ $t(fileError) }}
</template>

<script>
import platforms from '~/mixins/system/platforms'

export default {
  name: 'BlockKeyFileSelect',
  mixins: [platforms],
  props: {
    fileError: {
      type: String,
      default: null
    },
    fileSelected: {
      type: Boolean,
      default: false
    },
    fileName: {
      type: String,
      default: null
    },
    isStamp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileInputKey: 0
    }
  },
  computed: {
    text() {
      return this.isStamp ? this.$t('add stamp') : this.$t('Select eds key')
    },
    buttonText() {
      if (this.fileSelected) {
        return this.isStamp ? this.$t('Change stamp') : this.$t('Change key')
      }
      return this.isStamp ? this.$t('Add stamp') : this.$t('Add key')
    }
  },
  methods: {
    updateFileInputKey() {
      this.fileInputKey += 1
    },
    handleFileSelect() {
      if (this.$refs?.fileInput) {
        this.$refs.fileInput.click()
      }
    },
    handleFileSelected(e) {
      this.$emit('update:fileError', null)
      const file = this._.get(e, 'target.files[0]')
      if (file instanceof File) {
        const reader = new FileReader()
        reader.onloadend = e => {
          if (e.target.readyState !== FileReader.DONE) {
            return
          }
          try {
            const fileData = {
              file,
              data: new Uint8Array(e.target.result)
            }
            const commitName = this.isStamp ? 'edsKeys/SET_EDS_STAMP' : 'edsKeys/SET_EDS_KEY'
            this.$store.commit(commitName, fileData)
          } catch (e) {
            if (e instanceof RangeError) {
              this.$emit(
                'update:fileError',
                'File is too large to be processed. Please select another file'
              )
            } else {
              this.$emit('update:fileError', 'An error occurred while processing the file')
            }
          }
        }
        reader.readAsArrayBuffer(file)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.key-file-select {
  padding: 16px;
  border: 2px dashed #676767;
  border-radius: 16px;
  margin-bottom: 32px;

  &.errored {
    .key-file-select {
      &__file-input-key-icon {
        background: $danger;
      }

      &__file-input-btn {
        border-color: $danger !important;
        color: $danger !important;
      }
    }
  }
  &.successed {
    .key-file-select {
      &__input-key-icon {
        background: $text-dark;
      }

      &__file-input-btn {
        border-color: $primary !important;
        color: $primary !important;
      }
    }
  }

  &__input {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20px;

    @media (min-width: map-get($breakpoints, 'md')) {
      flex-wrap: nowrap;
    }

    &-key-icon {
      padding: 12px;
      border-radius: 12px;
      background: #f0f1f2;
      width: 48px;
      min-width: 48px;
      height: 48px;
      min-height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-text {
      flex-grow: 1;
      overflow: hidden;

      @media (min-width: map-get($breakpoints, 'sm')) {
        max-width: 235px;
      }

      h3 {
        margin-bottom: 4px;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      p {
        margin: 0;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    &-btn {
      width: 100%;
      max-width: 170px;
    }
  }

  &__error {
    font-size: 12px;
    color: $danger;
    width: 100%;
  }
}
</style>
